import { OrderItemRowResolver } from './types'

export const stampOrderItemRowResolver: OrderItemRowResolver = item => ({
    name: item.name || (item.stamp?.number ? `Штамп ${item.stamp.number}` : 'Штамп'),
    quantity: item.quantity,
    price: item.approvedPrice,
})
